import styled from "styled-components";

import { RelativeSizeIcon } from "../MetadataInfo.styled";

export const TableIcon = styled(RelativeSizeIcon)`
  transform: translateY(-1px);
`;
